var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell"},[_c('b-progress',{attrs:{"value":_vm.params.value,"show-progress":"","max":"'100'"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }